import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './vendors.actions.js';
import getters from './vendors.getters.js';
import mutations from './vendors.mutations.js';
import state from './vendors.state.js';

BaseStore.registerModule('vendors', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('vendors');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
